import AbstractEntity from "~/ts/library/AbstractEntity";

export default class CabinetNotification extends AbstractEntity {
    id: string;
    title: string;
    text: string;
    dateTime: string;
    isReaded: boolean;
}